import global from "./global.json";

export const en = {
  global,
};
